// assets/wishlist.js
(() => {
  const STORAGE_KEY = "at_wishlist_v1";
  const PENDING_KEY = "at_wishlist_pending_add";

  const read = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); }
    catch { return []; }
  };

  const write = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent("wishlist:updated", { detail: { items } }));
  };

  const has = (handle) => read().includes(handle);

  const add = (handle) => {
    const items = read();
    if (!items.includes(handle)) {
      items.unshift(handle);
      write(items);
    }
  };

  const remove = (handle) => {
    const items = read().filter((h) => h !== handle);
    write(items);
  };

  const toggle = (handle) => (has(handle) ? remove(handle) : add(handle));

  // ---------- AUTH MODAL ----------
  const openAuthModal = (handle) => {
    try {
      localStorage.setItem(PENDING_KEY, handle);
    } catch (e) {}

    const dlg = document.getElementById("WishlistAuthDialog");
    if (!dlg) return;

    // On construit des liens login/register avec return_url = URL actuelle + wishlist_add
    const current = new URL(window.location.href);
    current.searchParams.set("wishlist_add", handle);

    const returnUrl = encodeURIComponent(current.pathname + current.search);

    const loginA = dlg.querySelector("[data-wishlist-auth-login]");
    const regA = dlg.querySelector("[data-wishlist-auth-register]");

    if (loginA) loginA.href = `${loginA.getAttribute("href")}?return_url=${returnUrl}`;
    if (regA) regA.href = `${regA.getAttribute("href")}?return_url=${returnUrl}`;

    try { dlg.showModal(); } catch (e) { dlg.setAttribute("open", "open"); }
  };

  const bindAuthModal = () => {
    const dlg = document.getElementById("WishlistAuthDialog");
    if (!dlg) return;
    const closeBtn = dlg.querySelector("[data-wishlist-auth-close]");
    if (closeBtn) closeBtn.addEventListener("click", () => { try { dlg.close(); } catch { dlg.removeAttribute("open"); } });

    // clic backdrop = ferme
    dlg.addEventListener("click", (e) => {
      const rect = dlg.getBoundingClientRect();
      const inside = e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;
      if (!inside) { try { dlg.close(); } catch { dlg.removeAttribute("open"); } }
    });
  };

  // ---------- AUTO ADD AFTER LOGIN ----------
  const autoAddFromUrl = () => {
    if (!window.__customerLoggedIn) return;

    const url = new URL(window.location.href);
    const handle = url.searchParams.get("wishlist_add");

    if (handle) {
      add(handle);

      // Nettoyage URL
      url.searchParams.delete("wishlist_add");
      window.history.replaceState({}, "", url.pathname + (url.search ? url.search : ""));

      // Option : tu peux rediriger vers la wishlist après ajout auto
      // window.location.href = "/pages/wishlist";
    }
  };

  // Expose API
  window.Wishlist = { read, write, has, add, remove, toggle, openAuthModal, key: STORAGE_KEY };

  document.addEventListener("DOMContentLoaded", () => {
    bindAuthModal();
    autoAddFromUrl();
  });
})();